module.exports = __webpack_public_path__ + "static/img/main9back.ce2ca64b.jpg";